








import { Prop, Component,  Vue } from 'vue-property-decorator'
import { BarChart } from 'vue-chart-3'
import { Chart, ChartData, ChartOptions, BarController, BarElement, CategoryScale, LinearScale, Legend, Tooltip } from 'chart.js'
Chart.register(BarController, BarElement, CategoryScale, LinearScale, Legend, Tooltip)

@Component({
    components: {
        BarChart,
    },
})
export default class ChartBar extends Vue {
    @Prop({ default: () => [] }) readonly data!: ChartData
    @Prop({ default: () => [] }) readonly options!: ChartOptions<'bar'>
    @Prop({ default: () => [] }) readonly plugins!: object[]

    get chartOptions(): ChartOptions<'bar'> {
        return Object.assign({
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                easing: 'easeOutExpo',
            },
            plugins: {
                legend: {
                    position: 'right',
                },
                tooltip: {
                    backgroundColor: '#1e2a46',
                    titleFontSize: 18,
                    titleFontStyle: 'bold',
                    bodyFontSize: 18,
                    bodySpacing: 9,
                    xPadding: 9,
                    yPadding: 9,
                    caretSize: 16,
                },
            },
        }, this.options)
    }
}
